import { css } from 'aphrodite';
import * as React from 'react';
import { Skeleton } from '../../../../web/components-v2/Skeleton';
import type { Delta } from './reportsPresentation';
import { reportsStyles as rs } from './styles/reportsStyles';

interface ReportStatTileProps {
	label: string;
	value: string;
	delta?: Delta | null;
	isLoading?: boolean;
}

const DELTA_TONE_STYLES = {
	good: rs.deltaGood,
	bad: rs.deltaBad,
	neutral: rs.deltaNeutral,
} as const;

export const ReportStatTile: React.FC<ReportStatTileProps> = ({ label, value, delta, isLoading }) => {
	if (isLoading) {
		return (
			<Skeleton styles={[rs.statTile]}>
				<span className={css(rs.statLabel, rs.skeletonText)}>{label}</span>
				<span className={css(rs.statValue, rs.skeletonText)}>—</span>
			</Skeleton>
		);
	}

	return (
		<div className={css(rs.statTile)}>
			<span className={css(rs.statLabel)}>{label}</span>
			<span className={css(rs.statValue)}>{value}</span>
			{delta && (
				<span className={css(rs.statDelta, DELTA_TONE_STYLES[delta.tone])}>
					{delta.text} {delta.hint}
				</span>
			)}
		</div>
	);
};
